import { Modal, Button } from 'react-bootstrap';

export class ModalAyuda extends React.Component {
  constructor(props) {
      super(props);
      this.handleHide = this.handleHide.bind(this);
      this.handleShow = this.handleShow.bind(this);

      this.state = {
          showModal: false,
          sendActivation: true,
      };
  }

  componentDidMount() {
    this.setState({
      showModal: this.props.showModal,
    });
  }

  handleHide() {
    this.setState({
      showModal: false,
      sendActivation: false
    });
    this.props.handleHideModal && this.props.handleHideModal('showModalHelp');
  }

  handleShow() {
      this.setState({
          showModal: true,
          sendActivation: true
      });
  }

  handleShowWithActivation() {
      this.setState({
          showModal: true,
          sendActivation: true
      });
  }

  activateButton(activation) {
      this.setState({ sendActivation: activation });
  }

  render() {
      return (
          <div id="modal-wrap-alert-modal">
              <div className="modal-container">
                  <Modal
                      show={this.state.showModal}
                      container={this.props.container}
                      onHide={this.handleHide}
                      bsSize="large"
                      backdrop="static"
                      aria-labelledby="contained-modal-title-lg">
                      <Modal.Header>
                          <Modal.Title>
                              {this.props.MessageTitle}
                          </Modal.Title>
                          <Button className={this.props.NoX + ""} onClick={() => { this.handleHide(); this.props.CloseAction() }}>
                              <i className="fa fa-times"></i>
                          </Button>
                      </Modal.Header>
                      <Modal.Body>
                          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 modal-error-body modalInset">
                              {this.props.children}
                          </div>
                          <div className="inner-Model-buttons">
                              <Button className={this.props.NoAceptar + " btn btn-primary btn-si btn-left"} onClick={() => { this.handleHide(); this.props.MainButtonAction() }}>{this.props.MainButtonText}</Button>
                              <Button className={(this.props.NoCancelar + " btn btn-default btn-no btn-right") + (!this.state.sendActivation ? " disabled" : "")} disabled={!this.state.sendActivation} onClick={() => { this.handleHide(); this.props.AltButtonAction() }}>{this.props.AltButtonText}</Button>
                          </div>
                      </Modal.Body>
                  </Modal>
              </div>
          </div>
      );
  }
}

// const Modal = ReactBootstrap.Modal;
// const Button = ReactBootstrap.Button;